import { useSelector } from 'react-redux';
import useIsInitSuccessInfo from './useIsInitSuccessInfo';

export default function useGenerateState() {
    const {
        isfirstPassLoginSever,
        hasUsablePasscode,
        passcode,
        passcodeRemainingCount
    } = useSelector(s => s.promoState);
    const { currentLoginID, isLogin } = useSelector(s => s.userLoginState);
    const { qualifyWithdrawUuid } = useSelector(s => s.settingPointSystems);
    const { isNeedReducePoint, isNeedEnterPasscode } = useSelector(s => s.userEntryState);
    const isInitialized = useIsInitSuccessInfo();
    // 是否已登入
    const isLoginStatus = isInitialized && Boolean(isLogin);
    // 是否剛走過登入流程
    const isFirstPassLogin = isInitialized && isfirstPassLoginSever && Boolean(currentLoginID);
    // 啟用扣點且已扣點
    const isAfterReduceFeverPoint =
        isInitialized &&
        Boolean(qualifyWithdrawUuid) &&
        !isNeedReducePoint &&
        Boolean(currentLoginID);
    //啟用passcode passcode 可用且還有剩餘次數
    const isAfterVerifyPasscode =
        isInitialized &&
        Boolean(hasUsablePasscode) &&
        isNeedEnterPasscode &&
        Boolean(passcode) &&
        Number(passcodeRemainingCount) >= 1;

    return {
        isAfterReduceFeverPoint,
        isLoginStatus,
        isFirstPassLogin,
        isInitialized,
        isNeedReducePoint,
        isAfterVerifyPasscode
    };
}
